
















































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { FiConfigurationResource } from '@/api/reports/FiConfigurationResource';
import { FiConfiguration } from '@/api/reports/FiConfiguration';

@Component({
  computed: mapState(['fiId']),
})
export default class FiReportsFormatCard extends Vue {
  fiId!: string;

  loading: boolean = true;

  disabled: boolean = false;

  saving: boolean = false;

  fiConfiguration: FiConfiguration = {} as FiConfiguration;

  selectedFileFormat: string = '';

  availableFileFormats: string[] = ['XLSX', 'CSV', 'TXT'];

  @Inject('FiConfigurationResource')
  fiConfigurationResource!: FiConfigurationResource;

  isFiUser() {
    if (this.$store) {
      this.disabled = this.$store.state.isFiUser;
    }
  }

  mounted() {
    this.isFiUser();
    this.loadData();
  }

  @Watch('fiId')
  onFiChange() {
    this.fiConfiguration = {} as FiConfiguration;
    this.selectedFileFormat = '';
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.loadFiConfiguration();
  }

  async loadFiConfiguration() {
    this.fiConfiguration = {} as FiConfiguration;
    await this.fiConfigurationResource.getFiConfiguration(this.fiId).then((fiConfiguration: FiConfiguration) => {
      this.fiConfiguration = fiConfiguration;
      this.selectedFileFormat = fiConfiguration.fiReportFileFormat;
      this.loading = false;
    }).catch((error: any) => {
      this.showErrorMessage(error);
    });
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  async save() {
    this.saving = true;
    this.fiConfiguration.fiReportFileFormat = this.selectedFileFormat;
    await this.fiConfigurationResource.saveFiConfiguration(this.fiId, this.fiConfiguration).then((fiConfiguration: FiConfiguration) => {
      this.fiConfiguration = fiConfiguration;
      this.saving = false;
    }).catch((error) => {
      this.showErrorMessage(error);
    });
  }
}
